import { Fragment, useContext, useEffect, useState } from 'react';
import { Col, Card, CardHeader, Table, Form, FormGroup, Label, Input, ModalFooter, Row } from 'reactstrap';
import { Btn } from '../../AbstractElements';
import { useDispatch, useSelector } from 'react-redux';
import CommonModal from '../../Components/Modals/modal';
import Pagination from '../../Components/Pagination/Pagination';
import Empty from '../../Components/Empty/Index';
import SweetAlert from 'sweetalert2';
import { useLocation, useNavigate } from 'react-router';
import CustomizerContext from '../../_helper/Customizer';
import { addrecordedSubject, getrecordedSubject, statusDeleterecordedSubject, updaterecordedSubject } from '../../store/recordedSubjectSlice';
import { addliveChapter, deleteLiveChapter, deleteliveChapterData, getliveChapter, isOpenModal, ModalToggle, updateliveChapter, } from '../../store/liveChapterSlice';
import { getTeachers } from '../../store/teachersSlice';


const LiveChapterTable = () => {
  const storeVar = useSelector(state => state.liveChapter)
  const teacherVar = useSelector(state => state.teachers)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { layoutURL } = useContext(CustomizerContext);
  const toggle = () => dispatch(ModalToggle());
  const [mainId, setmainId] = useState()
  const [submit, setSubmit] = useState(false);
  const [formVar, setFormVar] = useState({
    keyword: '',
    limit: 30,
    offset: 0,
    currentPage: 1,
    modalTitle: null,
    editState: false,
    chapterId: '',
    title: '',
    teacherId: '',
  });

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get("id") || "";
    setmainId(id);
    dispatch(getliveChapter(formVar.limit, formVar.offset, id))
    dispatch(getTeachers(100, 0))

  }, []);

  const pageChange = (page) => {
    const offset = formVar.limit * (page - 1)
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      currentPage: page,
      offset: offset
    }))
    dispatch(getliveChapter(formVar.limit, offset, mainId))
  };

  const EditToggleModal = (data) => {
    dispatch(isOpenModal(true))
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: true,
      modalTitle: 'Edit Chapter',
      chapterId: data._id,
      title: data.title,
      teacherId: data.teacherId?._id
    }))
  }
  const AddToggleModal = () => {
    dispatch(isOpenModal(true))
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: false,
      modalTitle: 'Add Chapter',
      chapterId: '',
      title: '',
      teacherId: ''
    }))
  }


  const submitMenu = () => {
    if (titleValid() || teacherValid()) {
      setSubmit(true)
      return null
    }
    setSubmit(false)
    if (formVar.editState) {
      dispatch(updateliveChapter(formVar.chapterId, { title: formVar.title, teacherId: formVar.teacherId }))
    } else {
      dispatch(addliveChapter({ liveSubjectId: mainId, title: formVar.title, teacherId: formVar.teacherId }))
    }
  }


  const titleValid = () => {
    if (!formVar.title) {
      return "Title is required";
    }
  }
  const teacherValid = () => {
    if (!formVar.teacherId) {
      return "Teacher is required";
    }
  }

  const DeleteModel = (data) => {
    SweetAlert.fire({
      title: 'Are you sure?',
      text: 'Once deleted, you will not be able to recover this imaginary file!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    })
      .then((result) => {
        if (result.value) {
          dispatch(deleteLiveChapter(data._id))
        }
      });
  }

  const onNavigate = (data) => {
    navigate('/live-lessons/' + layoutURL + '?id=' + data._id)
  }







  return (
    <Fragment>
      <Col sm='12'>
        <Card>
          <CardHeader>
            <Row>
              <Col md="6">
              </Col>
              <Col md="4">
              </Col>
              <Col md="2" className='d-flex justify-content-end align-items-center'>
                <div className="text-end border-2 w-100">
                  <Btn attrBtn={{ color: 'info-gradien', className: 'w-100', size: 'sm', onClick: AddToggleModal }}>
                    Add Chapter
                  </Btn>
                </div>
              </Col>
            </Row>

          </CardHeader>
          <div className='table-responsive'>
            <Table hover={true} className='table-border-horizontal table-light'>
              <thead>
                <tr>
                  <th scope='col'>Sl.No</th>
                  <th scope='col'>Name</th>
                  <th scope='col'>Lessons</th>
                  <th scope='col'>Teacher</th>
                  <th scope='col'>Action</th>
                </tr>
              </thead>
              <tbody>
                {storeVar.liveChapterData?.map((item, index) => (
                  <tr key={index}>
                    <th scope='row'>{index + 1}</th>
                    <td >{item.title}</td>
                    <td >{item.liveClasses.length}</td>
                    <td >{item?.teacherId?.name}</td>


                    <td>
                      <div className='d-flex gap-2 align-items-center'>
                        <div className='cursor-pointer bg-light-primary font-primary action-icon'>
                          <i className="fa fa-edit fa-lg" onClick={(e) => EditToggleModal(item)}></i>
                          <div className="tooltipCustom">Edit</div>
                        </div>
                        <div className='cursor-pointer bg-light-primary font-success action-icon'>
                          <i className="fa fa-book fa-lg" onClick={() => onNavigate(item)}></i>
                          <div className="tooltipCustom">Lessons</div>
                        </div>
                        <div className='cursor-pointer bg-light-info font-danger action-icon'>
                          <i className="fa fa-trash fa-lg" onClick={(e) => DeleteModel(item)}></i>
                          <div className="tooltipCustom">Delete</div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {
            storeVar.totalliveChapter <= 0 && (
              <Empty />
            )
          }
        </Card>
        {
          storeVar.totalliveChapter > 0 &&
          <Pagination currentPage={formVar.currentPage} totalItem={storeVar.totalliveChapter}
            itemsPerPage={formVar.limit} showEllipsisAfter={true} visiblePageCount={3} onPageChange={pageChange} />
        }
      </Col>
      <CommonModal isOpen={storeVar.isOpenModal} title={formVar.modalTitle} toggler={toggle} >
        <Form>
          <FormGroup>
            <Label className="col-form-label" for="recipient-name">Title</Label>
            <Input className="form-control" type="text" placeholder='Enter Chapter Ttile' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, title: e.target.value }))} value={formVar.title} />
            {submit && titleValid() ? <span className='d-block font-danger'>{titleValid()}</span> : ""}
            <Label className="col-form-label" for="recipient-name">Teacher</Label>
            <Input className="form-control form-control-inverse btn-square" name="select" type="select"
              value={formVar.teacherId} onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, teacherId: e.target.value }))}>
              <option value=''>Select Teacher</option>
              {teacherVar.teachersData?.map((item, index) => (
                <option value={item._id} key={index}>{item.name+ " - " +item.subject}</option>
              ))}
            </Input>
            {submit && teacherValid() ? <span className='d-block font-danger'>{teacherValid()}</span> : ""}
          </FormGroup>
        </Form>
        <ModalFooter>
          <Btn attrBtn={{ color: 'secondary', onClick: toggle }} >Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitMenu }}>Save Changes</Btn>
        </ModalFooter>
      </CommonModal>
    </Fragment>
  );
};

export default LiveChapterTable;
